import { roundWithHighPrecision } from 'helpers/formatters/number';
import { useEffect, useMemo } from 'react';
import { FieldValues, UseFormSetValue } from 'react-hook-form';

type Props = {
  weightSumFieldName: string;
  lineItems: Record<string, any>;
  setValue: UseFormSetValue<FieldValues>;
  errors?: any;
  trigger?: any;
};

export const useWeightCalculations = ({
  weightSumFieldName,
  lineItems,
  setValue,
  errors,
}: Props) => {
  const weightSum = useMemo(
    () =>
      roundWithHighPrecision(
        lineItems.reduce(
          (acc: number, cur: any) => Number(acc) + Number(cur?.weight),
          0
        )
      ),
    [lineItems]
  );

  useEffect(() => {
    if (weightSum === 100 && errors[weightSumFieldName]) {
      delete errors[weightSumFieldName]; // TODO: yup validation persists
    }
    setValue(weightSumFieldName, weightSum, {
      shouldValidate: true,
    });
  }, [weightSum, weightSumFieldName, setValue]);

  return { weightSum };
};
